module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/baa/baa.component.scss
// module id = ./src/app/baa/baa.component.scss
// module chunks = main